import { ModalV2 } from './Common/ModalV2'
import { IconInfoCircle } from '@tabler/icons-react'

export const ErrorModal = ({
  open,
  onClose,
  title,
  description,
}: {
  open: boolean
  onClose: () => void
  title: string
  description: string
}) => {
  return (
    <ModalV2 open={open} onClose={onClose}>
      <h2 className="flex items-center gap-x-2 text-2xl font-bold">
        <IconInfoCircle className="mr-1 text-toasty-blue-500" size={18} />
        {title}
      </h2>
      <p className="mt-4 max-w-lg text-sm leading-5 text-gray-600">
        {description}
      </p>
      {description?.toLowerCase().includes('upgrade') && (
        <p className="mt-4 text-sm leading-5 text-gray-600">
          <a
            href="https://outcast.ai/pricing"
            target="_blank"
            rel="noreferrer"
            className="text-toasty-blue-600 underline"
          ></a>
        </p>
      )}
    </ModalV2>
  )
}
